import { Clock } from 'lucide-react'

/**
 * A read-only countdown badge that displays remaining days for a quarter.
 * This is a simplified version of the admin portal's CountdownBadge.
 */
export default function CountdownBadge({
  isStarted,
  isPaused,
  daysRemaining,
  loading = false,
  compact = false
}) {
  const getColorClasses = () => {
    if (!isStarted || daysRemaining === null) {
      return 'bg-gray-100 text-gray-600'
    }
    if (daysRemaining > 60) {
      return 'bg-green-100 text-green-700'
    }
    if (daysRemaining > 30) {
      return 'bg-amber-100 text-amber-700'
    }
    if (daysRemaining > 0) {
      return 'bg-red-100 text-red-700'
    }
    return 'bg-red-200 text-red-800'
  }

  if (loading) {
    return (
      <div className={`flex items-center gap-1 px-2 py-1 rounded ${getColorClasses()}`}>
        <Clock size={compact ? 14 : 16} className='animate-pulse' />
        <span className={compact ? 'text-xs' : 'text-sm'}>Loading...</span>
      </div>
    )
  }

  if (!isStarted) {
    return (
      <div className='flex items-center gap-1 px-2 py-1 rounded bg-gray-100 text-gray-500'>
        <Clock size={compact ? 14 : 16} />
        <span className={compact ? 'text-xs' : 'text-sm'}>Not started</span>
      </div>
    )
  }

  return (
    <div className={`flex items-center gap-1 px-2 py-1 rounded ${getColorClasses()}`}>
      <Clock size={compact ? 14 : 16} />
      <span className={compact ? 'text-xs font-medium' : 'text-sm font-medium'}>
        {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} {isPaused && '(Paused)'}
      </span>
    </div>
  )
}
